import { AbstractControl } from '@angular/forms';

export const baseRatingValidator = () => {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (control.value < 1 || control.value > 5) {
      return { ratingInvalid: true };
    }
    return null;
  };
};
